import { Component, OnInit, Input, Output, EventEmitter, TemplateRef } from '@angular/core';
import { NzDrawerRef, NzDrawerService } from 'ng-zorro-antd/drawer';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { AuthService, encryptStorage } from 'src/app/auth/auth.service';
import { VouchersSearch } from 'src/app/models/voucher';
import { emptyFields, purchaseTypeOptions, UsersType, UserTypes, voucherTypeOptions } from 'src/app/utilities/common-file';
import { CommonService } from 'src/app/utilities/common-service';
import { NzTableData } from 'src/app/utilities/nz-table.adapter';
import { VouchersService } from '../vouchers.service';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'app-active-voucher',
  templateUrl: './active-voucher.component.html',

})
export class ActiveVoucherComponent implements OnInit {

  private tableData: NzTableData<VouchersSearch, any> = new NzTableData<VouchersSearch, any>(new VouchersSearch(), 'fullName',);
  loading = false;
  merchantId: any;
  locationId: any;
  currencySymbol = '';
  selectedProduct: any;
  notifyLogout: any;
  selectedMerchantProduct: any;
  emptyField = emptyFields;
  userRole = UserTypes;
  role: string;
  vouchersTypeOptions = voucherTypeOptions;
  purchaseTypeOptions = purchaseTypeOptions;
  userType = UsersType;
  locationsList = [];
  loginUserType = '';
  voucherCodeModal: NzModalRef;
  voucherCode: any;
  validateLoading: boolean;
  locationListShow: boolean;
  errorMessage: any;
  locationData:any;
  deviceSignature = '';
  showAppCodeFilter= false;


  // tslint:disable-next-line: max-line-length
  constructor(private drawerService: NzDrawerService,
    private voucherService: VouchersService,
    private authService: AuthService,
    private commonService: CommonService,
    private modalService: NzModalService,
    private notification: NzNotificationService,
    private drawerRef: NzDrawerRef<string>,
    private message: NzMessageService) { }

  ngOnInit() {
    this.loginUserType = this.authService.getRole();
    this.tableData.search.merchantId = this.authService.getMerchantId();
    if (this.loginUserType === this.userRole.merchant) {
      this.locationListShow = true;
      this.locationsList = this.authService.getLocationDetails();
    } else {
      this.locationListShow = false;
      this.tableData.search.locationId = '';
      this.locationId = this.authService.getLocationId();
    }
    this.refresh();
    this.deviceSignature = this.authService.getDeviceSignature();
  }

  // For List

  refresh(startFromPageOne: boolean = true): void {
    this.loading = true;
    this.tableData.data = [];
    if (startFromPageOne) {
      this.tableData.pageIndex = 1;
    }
    this.tableData.search.merchantId = this.merchantId;
    if (this.loginUserType !== this.userType.merchantUser) {
      this.tableData.search.locationId = this.authService.getLocationId();
    }
    const args = {
      appCode: this.tableData.search.appCode ? this.tableData.search.appCode : '',
      pageIndex: this.tableData.pageIndex ? this.tableData.pageIndex : '',
      pageSize: this.tableData.pageSize ? this.tableData.pageSize : '',
      name: this.tableData.search.name ? this.tableData.search.name : '',
      type: this.tableData.search.type ? this.tableData.search.type : '',
      purchaseType: this.tableData.search.purchaseType ? this.tableData.search.purchaseType : '',

    }
    this.tableData.search.appCode = this.authService.getAppCode();
    this.voucherService.getVouchersList(args).subscribe((response: any) => {
      this.loading = false;
      this.tableData.total = response.data.total;
      if (response.data && response.data.activeVouchers) {
        this.tableData.data = response.data.activeVouchers;

      } else {
        this.tableData.data = [];

      }
    }, (err) => {
      this.loading = false;
      this.tableData.data = [];

    });
  }

  //  For Page Index change
  onIndexChange(event) {
    this.tableData.pageIndex = event;
    this.refresh(false);
  }

  // Modal Pop up 
  voucherCodeModalPopup(
    Title: TemplateRef<{}>,
    Content: TemplateRef<{}>,
    Footer: TemplateRef<{}>
  ) {

    this.voucherCodeModal = this.modalService.create({
      nzTitle: Title,
      nzContent: Content,
      nzFooter: Footer,
      nzMaskClosable: false,
      nzClosable: false,
      nzWidth: '35%',
      nzOnOk: () => console.log('Click ok'),
    });
  }

  validateVoucher() {
    if (this.voucherCode) {
      if (this.locationsList) {
        if (this.locationId) {
          this.errorMessage = '';
          this.validateLoading = true;
          const args = {
            voucherCode: this.voucherCode
          }
          this.voucherService.validateVoucher(args).subscribe((response: any) => {
            // this.validateLoading = false;
            if (response.success) {
              this.locationData = 'locationList';
              this.redeemVoucher('locationList');
              this.errorMessage = '';
            } else {

              this.errorMessage = response.message;
              this.validateLoading = false;
            }
          }, (err) => {

            this.validateLoading = false;
          });
        }
        else {
          this.validateLoading = false;
          this.notification.error('Please select location', '', {
            nzKey: 'key'
          });
        }

      }
      else {
        this.errorMessage = '';
        this.validateLoading = true;
        const args = {
          voucherCode: this.voucherCode
        }
        this.voucherService.validateVoucher(args).subscribe((response: any) => {
          // this.validateLoading = false;
          if (response.success) {
            this.locationData = 'locationId';
            this.redeemVoucher('locationId');
            this.errorMessage = '';

          } else {
            this.errorMessage = response.message;
            this.validateLoading = false;
          }
        }, (err) => {
          this.validateLoading = false;
        });
      }
    }
    else {
      this.validateLoading = false;
      this.notification.error('Please enter voucher code', '', {
        nzKey: 'key'
      });
    }

  }

  redeemVoucher(locationData) {
    this.validateLoading = true;
    const args = {
      voucherCode: this.voucherCode,
      merchantId: this.authService.getMerchantId(),
      locationId: this.locationId,
      deviceSignature: this.deviceSignature
    }
    console.log('redeem args',args);

    this.voucherService.redeeemVoucher(args).subscribe((response: any) => {
      this.validateLoading = false;
      if (response.success) {
        this.errorMessage = '';
        this.voucherCode = '';
        if(locationData == 'locationList'){
          this.locationId = '';
        }
        // this.notification.success(response.message, '', {
        //   nzKey: 'key'
        // });
        this.message.create('success', response.message);
        this.close();
      } else {
        this.errorMessage = response.message;
        this.validateLoading = false;
      }
    }, (err) => {
      this.validateLoading = false;
    });
  }

  clearSearch() {
    this.voucherCode = '';
  }

  close() {
    this.voucherCode = '';
    if(this.locationData == 'locationList'){
      this.locationId = '';
    }
    // this.locationListId = '';
    this.voucherCodeModal.close();

  }


  // To show currency symbol for amount
  getCurrency(currency) {
    return this.commonService.getCurrency(currency);
  }
  // To Show Voucher Type
  getVoucherType(type) {
    return this.commonService.getVoucherType(type);
  }
  // For User Voucher Type Tag color
  getVoucherTypeColor(type) {
    return this.commonService.getVoucherTypeColor(type);
  }
  // Clear search fields
  clearSearchVouchersFields(value) {
    return this.voucherService.clearSearchVouchersFields(this.tableData, value);
  }
  // To Show getVoucher Purchase Type 
  getVoucherPurchaseType(type) {
    return this.commonService.getVoucherPurchaseType(type);
  }
  // Forget Voucher Purchase Type Tag color
  getVoucherPurchaseTypeColor(type) {
    return this.commonService.getVoucherPurchaseTypeColor(type);
  }
  // For getting Appcode name
  // getAPPCode(data) {
  //   return this.authService.getAppCodeName(data);
  // }
  // // For getting tag color for appcode
  // getColorForAppCode(data) {
  //   return this.authService.getColorForAppCodes(data);
  // }
}
